import {
  Component,
  ElementRef,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FloatingShapeComponent } from '@catch/general-ui';
import { TranslocoPipe } from '@jsverse/transloco';
import { ScreenService } from '@catch/services';
import { TranslocoService } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import confetti from 'canvas-confetti';
import { fadeInOut } from '../../../../assets/animations/animations';
import { JobboardAdapter } from '../../../adapters/jobboard.adapter';
import { ColorService } from '../../../services/color.service';
import { SEOService } from '../../../services/seo.service';

const NONCE_UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

@UntilDestroy()
@Component({
  selector: 'app-renew-terms-consent',
  templateUrl: './renew-terms-consent.component.html',
  styleUrls: ['./renew-terms-consent.component.scss'],
  animations: [fadeInOut],
  imports: [FloatingShapeComponent, TranslocoPipe],
})
export class RenewTermsConsentComponent implements OnInit {
  private readonly colorService = inject(ColorService);
  private readonly jobboardAdapter = inject(JobboardAdapter);
  private readonly route = inject(ActivatedRoute);
  private readonly seoService = inject(SEOService);
  private readonly translateService = inject(TranslocoService);
  readonly screenService = inject(ScreenService);

  @ViewChild('confettiTrigger') confettiTrigger: ElementRef;

  state: string;

  ngOnInit(): void {
    this.colorService.setDefaultDesign();
    this.seoService.updateTitle(
      this.translateService.translate(
        'jobboard.views.renew-terms-consent.title',
      ),
    );
    this.seoService.updateDescription('');

    const nonce: string = this.route.snapshot.queryParams['nonce'];
    if (nonce && NONCE_UUID_RE.test(nonce)) {
      this.jobboardAdapter
        .renewTermsConsent(nonce)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: () => {
            this.state = 'success';
            this.showConfetti();
          },
          error: () => {
            this.state = 'failed';
          },
        });
    } else {
      this.state = 'failed';
    }
  }

  showConfetti(): void {
    confetti({
      particleCount: 50,
      spread: 70,
      origin: { y: 0.6 },
    });
  }

  get correctedBackgroundColor(): string {
    if (this.colorService.background) {
      if (
        this.colorService.background.startsWith('rgb') &&
        !this.colorService.background.startsWith('rgba')
      ) {
        return (
          this.colorService.background.substring(
            0,
            this.colorService.background.length - 2,
          ) + ', 0.133333)'
        );
      }
      if (
        this.colorService.background.startsWith('#') &&
        this.colorService.background.length <= 7
      ) {
        return this.colorService.background + '22';
      }
      return this.colorService.background;
    }
    return '';
  }
}
